module.exports = __webpack_public_path__ + "img/BoranBeefLogoHorizontal.908a9ed1.png";